import * as React from "react";
const ReportsView = React.lazy(() => import("./ReportsViewContainer"));

export { ReportsView };
